import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AuthGate } from './auth/AuthGate';
import { Dashboard } from './views/Dashboard';
import { Projects } from './views/Projects';
import { Priorities } from './views/Priorities';
import { YearPlan } from './views/YearPlan';
import { Budget } from './views/Budget';
import { Users } from './views/Users';
import { AdminOnly } from './auth/AdminOnly';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 15_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthGate>
        <AppShell>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/projekte" element={<Projects />} />
            <Route path="/prioritaeten" element={<Priorities />} />
            <Route path="/jahresplan" element={<YearPlan />} />
            <Route path="/budget" element={<Budget />} />
            <Route path="/benutzer" element={<AdminOnly><Users /></AdminOnly>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppShell>
        </AuthGate>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
